import { render, staticRenderFns } from "./StockTransferModal.vue?vue&type=template&id=39ad3a54&scoped=true&"
import script from "./StockTransferModal.vue?vue&type=script&lang=js&"
export * from "./StockTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./StockTransferModal.vue?vue&type=style&index=0&id=39ad3a54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ad3a54",
  null
  
)

export default component.exports